module.exports = __webpack_public_path__ + "486eccc65059990850957a9a4c200f62.pdf";